import { Component, Input } from '@angular/core';
import { AccordionData } from "../..";
var HTML_TEMPLATE = "\n<div class=\"od-accordion-item\" [ngClass]=\"{'od-conversation-expand':data.expand}\" [id]=\"id\">\n     <ng-content header></ng-content>\n     <ng-content body></ng-content>\n     <ng-content footer></ng-content>\n</div>";
var CSS_STYLE = "\n.od-accordion-item{\n\tposition:relative;\n}\n.od-accordion-item.od-conversation-expand > * {\n\tdisplay:flex;\n}\n\n.od-accordion-item > * {\n\tdisplay:none;\n}\n\n.od-accordion-item > *:first-child {\n\tdisplay:flex;\n}";
var AccordionItem = /** @class */ (function () {
    function AccordionItem() {
    }
    AccordionItem.decorators = [
        { type: Component, args: [{
                    selector: 'od-accordion-item',
                    template: HTML_TEMPLATE,
                    styles: [CSS_STYLE]
                },] },
    ];
    /** @nocollapse */
    AccordionItem.ctorParameters = function () { return []; };
    AccordionItem.propDecorators = {
        "data": [{ type: Input },],
        "id": [{ type: Input },],
    };
    return AccordionItem;
}());
export { AccordionItem };
//# sourceMappingURL=accordion-item.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui-components/accordion/accordion-item.js
// module id = 450
// module chunks = 14